<section>
  <ul>
    <li
      class="min-length"
      [class.met]="minLengthMet"
      [class.unmet]="!minLengthMet"
    >
      Must be at least {{ minLength }} characters
    </li>
    <li
      class="character-types"
      [class.met]="minCharacterTypesMet"
      [class.unmet]="!minCharacterTypesMet"
    >
      <span>
        Must contain {{ minCharacterTypes }} of the following
        {{ totalCharacterTypes }} types of characters:
      </span>
      <ul>
        <li
          *ngFor="let characterType of characterTypes"
          class="character-type-{{ characterType.type }}"
          [class.met]="characterType.met"
          [class.unmet]="!characterType.met"
        >
          {{ characterType.description }}
        </li>
      </ul>
    </li>
  </ul>
</section>
